import * as _ from 'lodash-es';
import {nanoid} from 'nanoid';
import {TableColumn, TableColumnConfig} from '../tables/table';

export interface DisplayColumn {
    key: string;
    label: string;
    isVisible: boolean;
    columnDef: TableColumn;
    isGroupedColumn: boolean;

    /**
     * An application-wide unique id for the form field.
     * It's aimed to be used as the input's DOM element ID attribute.
     */
    formFieldId: string;

    /**
     * isGroupDependent is True if the column is part of a group
     * and isn't the first column in the group (shouldn't have its own checkbox).
     */
    isGroupDependent: boolean;
}

export class DisplayColumnsFactory {

    public static createDisplayColumns(columns: TableColumn[], columnsSettings: TableColumnConfig[]): DisplayColumn[] {
        const formFieldPrefix = nanoid();
        const groupKnowledgeById = new Set<any>();

        return columns
            .filter(columnDef => !columnDef.isRequired && !columnDef.isHidden)
            .map((columnDef: TableColumn): DisplayColumn => {
                const groupId = columnDef.groupId;
                const isGroupedColumn: boolean = groupId !== null && groupId !== undefined;
                const isGroupDependent = isGroupedColumn && groupKnowledgeById.has(groupId);

                groupKnowledgeById.add(groupId);

                return {
                    key: columnDef.key,
                    label: columnDef.label,
                    isVisible: _.some(columnsSettings, {key: columnDef.key}),
                    columnDef,
                    isGroupedColumn,
                    formFieldId: `column-${formFieldPrefix}-${columnDef.key}`,
                    isGroupDependent
                };
            });
    }

}
